var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4077 14.7505C11.8574 14.7505 13.0327 13.5752 13.0327 12.1255C13.0327 10.6757 11.8574 9.50047 10.4077 9.50047C9.7895 9.50047 9.22134 9.71428 8.77281 10.0718L5.97046 8.32034C6.01115 8.13627 6.03262 7.945 6.03262 7.74876C6.03262 7.55252 6.01115 7.36464 5.97046 7.18058L8.77281 5.42909C9.22134 5.78667 9.7895 6.00048 10.4077 6.00048C11.8574 6.00048 13.0327 4.8252 13.0327 3.37548C13.0327 1.92576 11.8574 0.750488 10.4077 0.750488C8.95797 0.750488 7.7827 1.92576 7.7827 3.37548C7.7827 3.57121 7.8043 3.76185 7.84494 3.94535L5.04259 5.69681C4.59406 5.33929 4.02591 5.12548 3.40771 5.12548C1.95799 5.12548 0.782715 6.30075 0.782715 7.75047C0.782715 9.20019 1.95799 10.3755 3.40771 10.3755C4.02591 10.3755 4.59406 10.1617 5.04259 9.80413L7.84494 11.5556C7.81781 11.6781 7.79923 11.8039 7.78985 11.9321L7.78278 12.1264C7.78278 12.1266 7.7827 12.1252 7.7827 12.1255C7.7827 13.5752 8.95797 14.7505 10.4077 14.7505Z",
    fill: "#B97E12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAlt);
export default __webpack_public_path__ + "static/media/share-alt.e20b89ffb726db985c10b554f4498802.svg";
export { ForwardRef as ReactComponent };